import React from 'react';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import DialogTitle from 'core/ui/Dialog/DialogTitle';
import Box from 'core/ui/Box';
import Texture from 'core/ui/Texture';
import Grid from 'core/ui/Grid';
import Button, { ButtonPrimary } from 'core/ui/Button';
import LoaderSm from 'core/ui/LoaderSm';
import { Send } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { secondaryBgModal } from 'core/ui/Colors';
import Divider from 'core/ui/Divider';
import Typography from 'core/ui/Typography';
import UsersSelector from './UsersSelector';
import FormSend from './FormSend';
import useForm from './useForm';
import CompetitionsUsersSelector from './CompetitionsUsersSelector';

export default function ModalFormMessage({
  ownerableType,
  ownerableId,
  message,
  open,
  close,
  callback,
  automated,
}) {
  const textService = useForm({ ownerableType, ownerableId, message, callback, automated });
  const { t } = useTranslation();
  return (
    <Dialog open={open} maxWidth="xl" fullWidth onClose={() => close()}>
      <DialogTitle background onClose={() => close()}>
        {t('channel.message')}
      </DialogTitle>

      <Dialog
        open={textService.modalAlertPayment?.open}
        onClose={() => textService.setModalAlertPayment({ open: false })}
      >
        <Texture>
          <Box p={5}>
            <Typography>{t('channel.messages.overlimit')}</Typography>
          </Box>
        </Texture>
        <DialogActions style={{ backgroundColor: secondaryBgModal }}>
          {textService.loadingSend ? (
            <LoaderSm loading />
          ) : (
            <Box display="flex" px={3}>
              <Button onClick={() => textService.setModalAlertPayment({ open: false })}>
                {t('button.cancel')}
              </Button>
              <Button onClick={() => textService.handleSubmit(textService.onSubmitWithPayment)()}>
                {t('button.confirm')}
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>

      <Texture>
        <DialogContent>
          <Box p={3}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={8}>
                <FormSend
                  callback={callback}
                  ownerableType={ownerableType}
                  textService={textService}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                {ownerableType === 'Channel' && (
                  <UsersSelector channelId={ownerableId} textService={textService} />
                )}
                {ownerableType === 'Competition' && (
                  <>
                    <CompetitionsUsersSelector textService={textService} />
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <Divider m={3} />
      </Texture>

      <DialogActions style={{ backgroundColor: secondaryBgModal }}>
        <Box display="flex" px={3}>
          <Button style={{ marginRight: 5 }} onClick={close} color="primary">
            Cancel
          </Button>
          <ButtonPrimary
            disabled={textService.loadingSend}
            onClick={() => textService.handleSubmit(textService.onSubmit)()}
          >
            {textService.loadingSend ? (
              <LoaderSm loading width={20} />
            ) : (
              <Send style={{ fontSize: 15 }} />
            )}
            &nbsp;{t(textService?.watch('scheduleSend') ? 'button.save' : 'button.send')}
          </ButtonPrimary>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
